import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "main-error"
};
const _hoisted_2 = {
    key: 0,
    class: "title clamp-text"
};
const _hoisted_3 = {
    key: 1,
    class: "title clamp-text"
};
const _hoisted_4 = { class: "subtitle" };
const _hoisted_5 = { class: "inputs" };
const _hoisted_6 = { class: "line" };
const _hoisted_7 = { class: "info-block" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "line" };
const _hoisted_10 = { class: "inputs" };
const _hoisted_11 = { class: "label" };
const _hoisted_12 = { class: "info-block" };
const _hoisted_13 = { class: "mt-2 d-flex justify-content-between gray-color grey-info" };
const _hoisted_14 = { class: "d-flex flex-column" };
const _hoisted_15 = { class: "text-end" };
const _hoisted_16 = { class: "text-balance" };
const _hoisted_17 = { class: "gray-color" };
const _hoisted_18 = { class: "btn-block" };
const _hoisted_19 = { class: "title" };
const _hoisted_20 = { class: "subtitle" };
const _hoisted_21 = { class: "text-[15px]" };
const _hoisted_22 = { class: "d-flex flex-col gap-1 mt-1 ml-3" };
const _hoisted_23 = { class: "d-flex gap-2" };
const _hoisted_24 = {
    class: "checkbox-label",
    for: "termsCheckbox"
};
const _hoisted_25 = ["id", "onUpdate:modelValue"];
const _hoisted_26 = ["for"];
const _hoisted_27 = ["disabled", "onClick"];
const _hoisted_28 = { class: "title" };
const _hoisted_29 = { class: "subtitle" };
const _hoisted_30 = { class: "verify" };
const _hoisted_31 = { class: "title" };
const _hoisted_32 = { class: "subtitle" };
const _hoisted_33 = { class: "d-flex align-items-center gap-3" };
const _hoisted_34 = { class: "progresses" };
const _hoisted_35 = ["checked"];
const _hoisted_36 = ["checked"];
const _hoisted_37 = ["checked"];
const _hoisted_38 = ["checked"];
const _hoisted_39 = ["checked"];
const _hoisted_40 = {
    key: 0,
    class: "text-error"
};
const _hoisted_41 = { class: "final-titles" };
const _hoisted_42 = { class: "title" };
const _hoisted_43 = {
    key: 0,
    class: "subtitle clamp-text lh-style"
};
const _hoisted_44 = {
    key: 1,
    class: "subtitle clamp-text lh-style"
};
const _hoisted_45 = { class: "result" };
const _hoisted_46 = { key: 0 };
const _hoisted_47 = ["href"];
const _hoisted_48 = {
    key: 0,
    class: "final-buttons"
};
const _hoisted_49 = {
    key: 1,
    class: "final-buttons"
};
const _hoisted_50 = ["step"];
const _hoisted_51 = {
    key: 1,
    class: "warning"
};
const _hoisted_52 = { key: 2 };
const _hoisted_53 = {
    key: 3,
    class: "final-buttons"
};
const _hoisted_54 = {
    key: 4,
    class: "error mt-2"
};
import _ from "lodash";
import BigNumber from "bignumber.js";
import moment from "moment";
import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import ProgressBar from "@/components/progressBar/ProgressBar.vue";
import Terms from "@/components/capital/Terms.vue";
import TermsEqual from "@/components/capital/TermsEqual.vue";
import TermsVote from "@/components/capital/TermsVote.vue";
import { checkAccess, getAccessDeniedReasonsText, scope } from "@/help/accessData";
import { investmentFormCheckboxes } from "@/help/investmentFormCheckboxes";
import AuList from "@/components/extended/AuList.vue";
import UDialog from "@/components/uikit/uComponents/UDialog.vue";
import UForm from "@/components/uikit/uComponents/uForm/UForm.vue";
import { useI18n } from "@/localization/localizator";
import { useUser } from "@/composables/useAuth";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectInvestModal',
    props: {
        modelValue: { type: Boolean },
        investAmount: { default: "" }
    },
    emits: ["update:modelValue", "finish"],
    setup(__props, { emit: __emit }) {
        const t = useI18n();
        const STATES = {
            NOT_STARTED: 0,
            IN_PROGRESS: 1,
            DONE: 2,
            FAIL: 3
        };
        // Props
        const props = __props;
        // Emits
        const emit = __emit;
        // Composables
        const router = useRouter();
        const store = useStore();
        // Refs
        const isDirty = ref(false);
        const moneyAmount = ref("");
        const step = ref(1);
        const token = ref("");
        const termsAgree = ref(false);
        const errorText = ref("");
        const address = ref("");
        const hash = ref("");
        const checkboxesData = ref([]);
        const transactionsChecks = ref({
            terms: STATES.NOT_STARTED,
            balance: STATES.NOT_STARTED,
            smartcontract: STATES.NOT_STARTED,
            received: STATES.NOT_STARTED,
            sent: STATES.NOT_STARTED
        });
        // Computed
        const cssVars = computed(() => ({
            "--height": "200px"
        }));
        const project = computed(() => store.getters["capitals/auCapital"]);
        const modalHeight = computed(() => {
            let height = 538;
            if (step.value == 1) {
                if (testerRole.value && project.value?.applicationType == "stakingPool") {
                    height = 550;
                }
            }
            else if (step.value == 2) {
                height += checkboxesData.value.length * 12;
            }
            return height + "px";
        });
        const testerRole = computed(() => store.getters["profile/isTestRole"]);
        const amountAvailable = computed(() => {
            if (isOpenSale.value) {
                return BigNumber(project.value?.openSaleLimit ?? 0).multipliedBy(BigNumber(10).pow(project.value.tokenQuote?.decimals)).toString(10);
            }
            else {
                return BigNumber(project.value.maxCap).minus(project.value?.currentCap).toString(10);
            }
        });
        const infoStep1 = computed(() => {
            const addition = project.value.tokenQuote.mnemonicEng;
            return [
                [
                    { title: "auCapitals.projectCard.information.staked", value: "XXX", addition },
                    {
                        title: "auCapitals.projectCard.information.available",
                        value: amountAvailable.value,
                        decimal: project.value?.tokenQuote?.decimals,
                        indent: project.value?.tokenQuote?.indent,
                        addition: project.value?.tokenQuote?.mnemonicEng
                    }
                ]
            ];
        });
        const infoStep3 = computed(() => {
            return [
                [
                    { title: t("auCapitals.capitalModal.3step.project"), value: project.value.nameEng },
                    { title: t(`auCapitals.capitalModal.3step.payWith${vote.value}`), value: selectedToken.value },
                    { title: t(`auCapitals.capitalModal.3step.amount${vote.value}`), value: moneyAmount.value.toString().replace(",", ".") },
                    { title: t("auCapitals.capitalModal.3step.fees", { platform: process.env.VUE_APP_PLATFORM }), value: "-" }
                ]
            ];
        });
        const subtitle = computed(() => isVoting.value ? t("auCapitals.capitalModal.5step.subtitleVoted") : t("auCapitals.capitalModal.5step.subtitle"));
        const link = computed(() => {
            let link = `${process.env.VUE_APP_SCAN_BASE_URL}`;
            if (hash.value) {
                link += "tx/" + hash.value;
            }
            return link;
        });
        const priceBase = computed(() => {
            let value = BigNumber(project.value.priceBase);
            value = value.dividedBy(BigNumber(10).pow(project.value.tokenQuote?.decimals));
            return value.toNumber();
        });
        const min = computed(() => {
            return minQuote.value ? _.max([priceBase.value, minQuote.value]) || 0 : priceBase.value;
        });
        const max = computed(() => {
            const maxAvailable = isOpenSale.value ?
                BigNumber(project.value?.openSaleLimit ?? 0).multipliedBy(BigNumber(10).pow(project.value.tokenQuote?.decimals)) :
                BigNumber(project.value.maxCap).minus(project.value.currentCap);
            let userHasAmount = BigNumber(owner.value.amountFree);
            userHasAmount = userHasAmount.dividedBy(BigNumber(10).pow(project.value.tokenQuote?.decimals));
            userHasAmount = userHasAmount.dividedBy(priceBase.value).integerValue(BigNumber.ROUND_FLOOR);
            let userHasAmountNumber = userHasAmount.multipliedBy(priceBase.value).toNumber();
            let amountToMax = BigNumber(maxAvailable);
            let amountToMaxNumber = amountToMax.dividedBy(BigNumber(10).pow(project.value.tokenQuote?.decimals)).toNumber();
            return maxQuote.value ?
                _.min([amountToMaxNumber, maxQuote.value, userHasAmountNumber]) || 0 :
                _.min([amountToMaxNumber, userHasAmountNumber]) || 0;
        });
        const procent = computed(() => {
            let procent = 0;
            for (const property in transactionsChecks.value) {
                if (transactionsChecks.value[property] == STATES.DONE) {
                    procent += 20;
                }
            }
            return procent;
        });
        const maxQuote = computed(() => {
            if (!project.value.quote) {
                return undefined;
            }
            let value = BigNumber(project.value.priceBase);
            value = value.dividedBy(BigNumber(10).pow(project.value.tokenQuote?.decimals));
            value = value.multipliedBy(project.value.quote);
            return value.toNumber();
        });
        const minQuote = computed(() => {
            if (!project.value.minCount) {
                return 0;
            }
            let value = BigNumber(project.value.priceBase);
            value = value.dividedBy(BigNumber(10).pow(project.value.tokenQuote?.decimals));
            value = value.multipliedBy(project.value.minCount);
            return value.toNumber();
        });
        const isEnough = computed(() => {
            let count = BigNumber(moneyAmount.value.toString().replace(",", "."));
            if (owner.value === undefined) {
                return false;
            }
            let value = BigNumber(owner.value.amountFree);
            value = value.dividedBy(BigNumber(10).pow(project.value.tokenQuote?.decimals));
            return count.isLessThanOrEqualTo(value);
        });
        const owner = computed(() => store.getters["owner/auOwners"].find((item) => item.auToken.id == project.value.tokenQuote?.id));
        const tokenCount = computed(() => {
            let tokenCount = BigNumber(moneyAmount.value.toString().replace(",", "."));
            tokenCount = tokenCount.dividedBy(priceBase.value);
            return tokenCount.toNumber();
        });
        const tokensOptions = computed(() => {
            const tokens = [...store.getters.tokensUtility, ...store.getters.tokensFiat, ...store.getters.tokensGold];
            const res = _.find(tokens, (token) => token.mnemonicEng === project.value.tokenQuote?.mnemonicEng);
            return [{
                    display: res?.mnemonicEng,
                    value: res?.id
                }];
        });
        const isNextBolcked = computed(() => {
            if (isAmountIncorrect.value) {
                return true;
            }
            if (!isEnough.value) {
                return true;
            }
            if (Number(moneyAmount.value) < min.value) {
                return true;
            }
            if (step.value == 1 && Number(moneyAmount.value) == 0) {
                return true;
            }
            if (step.value == 2 && !(termsAgree.value && _.every(checkboxesData.value, agreement => agreement.checked))) {
                return true;
            }
            if (step.value == 4 && transactionsChecks.value.received != STATES.DONE) {
                return true;
            }
            return false;
        });
        const clampedName = computed(() => project.value.nameEng);
        const selectedToken = computed(() => _.chain(tokensOptions.value).find(v => v.value == token.value).get("display").value());
        const isAmountIncorrect = computed(() => Math.trunc(tokenCount.value) !== Number(tokenCount.value));
        const amountToFix = computed(() => {
            let amount = BigNumber(tokenCount.value).integerValue(BigNumber.ROUND_DOWN);
            amount = amount.multipliedBy(priceBase.value);
            return amount.isGreaterThan(min.value) ? amount.toString(10) : min.value;
        });
        const isVoting = computed(() => project.value?.projectType === "voting");
        const isStakingPool = computed(() => project.value?.applicationType === "stakingPool");
        const projectTerms = computed(() => process.env.VUE_APP_TERMS);
        const vote = computed(() => isVoting.value ? "Vote" : "");
        const hasAccessToDeposit = computed(() => checkAccess(scope.deposit));
        const accessDeniedReasonsText = computed(() => {
            const textParams = { platform: process.env.VUE_APP_PLATFORM };
            return getAccessDeniedReasonsText(scope.deposit, textParams);
        });
        const isOpenSale = computed(() => project.value?.hasOpenSale && project.value.isSuccess);
        // Watchers
        watch(step, async (value) => {
            if (value == 4) {
                transactionsChecks.value.terms = STATES.IN_PROGRESS;
                await new Promise(r => setTimeout(r, 500));
                transactionsChecks.value.terms = STATES.DONE;
                transactionsChecks.value.balance = STATES.IN_PROGRESS;
                try {
                    await store.dispatch("owner/getAuOwners");
                    if (!isEnough.value) {
                        errorText.value = "auCapitals.capitalModal.errors.balance";
                        transactionsChecks.value.balance = STATES.FAIL;
                        return;
                    }
                }
                catch (error) {
                    errorText.value = "auCapitals.capitalModal.errors.balanceError";
                    transactionsChecks.value.balance = STATES.FAIL;
                    return;
                }
                transactionsChecks.value.balance = STATES.DONE;
                transactionsChecks.value.smartcontract = STATES.IN_PROGRESS;
                await new Promise(r => setTimeout(r, 500));
                transactionsChecks.value.smartcontract = STATES.DONE;
                transactionsChecks.value.received = STATES.IN_PROGRESS;
                let invest = null;
                try {
                    if (isOpenSale.value) {
                        invest = await getOpenSaleTokens();
                    }
                    else {
                        invest = await investCapital();
                    }
                    if (!invest.data) {
                        errorText.value = "auCapitals.capitalModal.errors.transaction";
                        transactionsChecks.value.received = STATES.FAIL;
                        return;
                    }
                    else if (invest.status == 267) {
                        const message = invest.data.message || invest.data.detail;
                        if (message) {
                            errorText.value = message;
                        }
                        else {
                            errorText.value = "auCapitals.capitalModal.errors.purchase";
                        }
                        transactionsChecks.value.received = STATES.FAIL;
                        return;
                    }
                }
                catch (error) {
                    errorText.value = "auCapitals.capitalModal.errors.transaction";
                    transactionsChecks.value.received = STATES.FAIL;
                    return;
                }
                transactionsChecks.value.received = STATES.DONE;
                transactionsChecks.value.sent = STATES.IN_PROGRESS;
                if (!isOpenSale.value) {
                    for (;;) {
                        try {
                            const data = await store.dispatch("getTokenEventById", invest.data?.id);
                            if (data.isTaskDone) {
                                address.value = data.address;
                                const transactions = await store.dispatch("getTransactionsByAddress", {
                                    addressFrom: owner.value.auToken?.createdAddress,
                                    addressTo: data.address
                                });
                                hash.value = _.first(transactions)?.hash || "";
                                if (data.value == "0") {
                                    errorText.value = "auCapitals.capitalModal.errors.zeroValue";
                                    transactionsChecks.value.sent = STATES.FAIL;
                                    return;
                                }
                                moneyAmount.value = BigNumber(data.value).multipliedBy(priceBase.value).toNumber().toString();
                                break;
                            }
                            else if (data.isError) {
                                errorText.value = "auCapitals.capitalModal.errors.transaction";
                                transactionsChecks.value.sent = STATES.FAIL;
                                return;
                            }
                        }
                        catch (error) {
                            errorText.value = "auCapitals.capitalModal.errors.checking";
                            transactionsChecks.value.sent = STATES.FAIL;
                            return;
                        }
                        await store.dispatch("capitals/getInvestmentsNoPagination");
                        await new Promise(r => setTimeout(r, 5000));
                    }
                }
                emit("finish");
                // try {
                //   if (window.carrotquest && process.env.VUE_APP_CARROT_ENABLED === "true") {
                //     window.carrotquest.track("invest", {
                //       "address": address.value,
                //       "amount": Math.trunc(tokenCount.value).toString(10)
                //     });
                //   }
                // }
                // catch (error) {
                //   console.error(error);
                // }
                transactionsChecks.value.sent = STATES.DONE;
            }
        });
        // Methods
        const setMoneyAmount = (value) => {
            isDirty.value = true;
            moneyAmount.value = value;
        };
        const tryDownloadMemorandum = async (index) => {
            const checkboxData = checkboxesData.value[index];
            if (!checkboxData.loading) {
                try {
                    checkboxData.loading = true;
                    await store.dispatch("capitals/downloadMemorandum", {
                        url: checkboxData.link,
                        name: checkboxData.name,
                        sum: /memorandum/i.test(checkboxData.name) ? moneyAmount.value : null
                    });
                }
                catch (error) {
                    console.error(error);
                }
                finally {
                    checkboxData.loading = false;
                }
            }
        };
        const getAmount = (percent) => {
            let amountFree = BigNumber(owner.value.amountFree);
            amountFree = amountFree.dividedBy(BigNumber(10).pow(project.value.tokenQuote?.decimals));
            let calculatedAmount = amountFree.multipliedBy(percent).dividedBy(100);
            calculatedAmount = calculatedAmount.integerValue(BigNumber.ROUND_UP);
            if (calculatedAmount.isGreaterThanOrEqualTo(max.value)) {
                moneyAmount.value = max.value.toString();
            }
            else {
                moneyAmount.value = calculatedAmount.toString(10);
            }
            fixAmount();
        };
        const fixAmount = () => {
            moneyAmount.value = BigNumber(Math.trunc(tokenCount.value)).multipliedBy(priceBase.value).toString();
        };
        const user = useUser();
        const investCapital = async () => {
            const params = {
                user: `/api/users/${user?.id}`,
                createdAt: moment(),
                type: "token_capital_buy",
                description: "buy",
                value: Math.trunc(tokenCount.value).toString(10),
                address: "",
                isTask: true,
                auCapital: `api/au_capitals/${project.value.id}`
            };
            const invest = await store.dispatch("sendTokenEvents", params);
            return invest;
        };
        const getOpenSaleTokens = async () => {
            const params = {
                value: Math.trunc(tokenCount.value).toString(10)
            };
            return await store.dispatch("investInOpenSale", { id: project.value.id, params: params });
        };
        // Lifecycle
        onMounted(async () => {
            await store.dispatch("getBalances", store.getters["defaultToken/defaultTokenId"]);
            await store.dispatch("owner/getAuOwners");
            checkboxesData.value = investmentFormCheckboxes(process.env.VUE_APP_VENDOR, project.value.id.toString(), project.value.nameEng);
            token.value = project.value.tokenQuote?.id.toString();
            if (props.investAmount?.length > 0) {
                moneyAmount.value = props.investAmount;
            }
        });
        return (_ctx, _cache) => {
            const _component_AuSelect = _resolveComponent("AuSelect");
            const _component_AuDecimalStatic = _resolveComponent("AuDecimalStatic");
            const _component_RouterLink = _resolveComponent("RouterLink");
            const _component_AuInput = _resolveComponent("AuInput");
            const _component_AuButton = _resolveComponent("AuButton");
            const _component_UList = _resolveComponent("UList");
            return (_openBlock(), _createBlock(UDialog, {
                visible: __props.modelValue,
                title: `${step.value.toString()} from 4`,
                class: "capital-modal",
                height: modalHeight.value,
                "onUpdate:visible": _cache[11] || (_cache[11] = ($event) => (_ctx.$emit('update:modelValue', false)))
            }, {
                default: _withCtx(() => [
                    _createVNode(UForm, {
                        padding: "0px",
                        class: "h-full"
                    }, {
                        submit: _withCtx(() => [
                            (!owner.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _createVNode(_component_AuButton, {
                                        disabled: !hasAccessToDeposit.value,
                                        bordered: "",
                                        center: "",
                                        "active-bg-color": "#2ABA7C",
                                        onClick: _cache[6] || (_cache[6] = ($event) => (_unref(router).push({ name: 'buy form' })))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.topUp") + " " + project.value.tokenQuote?.mnemonicEng), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["disabled"])
                                ]))
                                : (errorText.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                        _createVNode(_component_AuButton, {
                                            class: "button",
                                            bordered: "",
                                            center: "",
                                            "active-bg-color": "#ba2a2a",
                                            onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.$emit('update:modelValue', false)))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.close")), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]))
                                    : (step.value < 5)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            step: step.value,
                                            class: "main-buttons"
                                        }, [
                                            (step.value > 1 && step.value < 4)
                                                ? (_openBlock(), _createBlock(_component_AuButton, {
                                                    key: 0,
                                                    class: "back-button",
                                                    bordered: "",
                                                    center: "",
                                                    onClick: _cache[8] || (_cache[8] = ($event) => (step.value--))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.back")), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (isAmountIncorrect.value && step.value <= 3 && isDirty.value)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                                    _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.warning")) + " ", 1),
                                                    _createVNode(_component_AuDecimalStatic, {
                                                        value: amountToFix.value,
                                                        decimal: 0,
                                                        indent: project.value.tokenQuote?.decimals,
                                                        addition: tokensOptions.value[0]?.display,
                                                        onClick: fixAmount
                                                    }, null, 8, ["value", "indent", "addition"])
                                                ]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_52)),
                                            _createVNode(_component_AuButton, {
                                                id: "for-test-button-next",
                                                class: "button",
                                                bordered: "",
                                                center: "",
                                                type: "primary",
                                                "active-bg-color": "#2ABA7C",
                                                disabled: isNextBolcked.value,
                                                onClick: _cache[9] || (_cache[9] = ($event) => (step.value++))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.next")), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["disabled"])
                                        ], 8, _hoisted_50))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                            _createVNode(_component_AuButton, {
                                                class: "button",
                                                bordered: "",
                                                center: "",
                                                type: "primary",
                                                "active-bg-color": "#2ABA7C",
                                                onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.$emit('update:modelValue', false)))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.anotherInvestment")), 1)
                                                ]),
                                                _: 1
                                            })
                                        ])),
                            (!hasAccessToDeposit.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(accessDeniedReasonsText.value), 1))
                                : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                            _createVNode(_component_UList, { gap: "0px" }, {
                                default: _withCtx(() => [
                                    (!owner.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)("auCapitals.capitalModal.error", { token: project.value.tokenQuote?.mnemonicEng })), 1))
                                        : (step.value == 1)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                (isStakingPool.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)(`auCapitals.capitalModal.1step.titleStakingPool`)), 1))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)(`auCapitals.capitalModal.1step.title${vote.value}`)) + " " + _toDisplayString(project.value.nameEng), 1)),
                                                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(`auCapitals.capitalModal.1step.subtitle${vote.value}`)), 1),
                                                _createElementVNode("div", _hoisted_5, [
                                                    _createElementVNode("div", _hoisted_6, [
                                                        _createVNode(_component_AuSelect, {
                                                            value: token.value,
                                                            disabled: "",
                                                            options: tokensOptions.value,
                                                            placeholder: _unref(t)(`auCapitals.capitalModal.1step.payWith${vote.value}`),
                                                            "select-label": _unref(t)(`auCapitals.capitalModal.1step.payWith${vote.value}`),
                                                            onInput: _cache[0] || (_cache[0] = (value) => (token.value = value))
                                                        }, null, 8, ["value", "options", "placeholder", "select-label"]),
                                                        _createElementVNode("div", _hoisted_7, [
                                                            _createElementVNode("span", null, _toDisplayString(_unref(t)("auCapitals.capitalModal.1step.yourBalance")), 1),
                                                            _createElementVNode("span", null, [
                                                                _createVNode(_component_AuDecimalStatic, {
                                                                    value: owner.value.amountFree,
                                                                    decimal: owner.value.auToken.decimals,
                                                                    indent: owner.value.auToken.indent,
                                                                    "show-addition": false
                                                                }, null, 8, ["value", "decimal", "indent"]),
                                                                _createVNode(_component_RouterLink, {
                                                                    class: "link",
                                                                    to: "/my-assets/buy-form"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.1step.deposit")), 1)
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ])
                                                        ])
                                                    ]),
                                                    (project.value?.applicationType == 'stakingPool' && testerRole.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                            _createVNode(AuList, { items: infoStep1.value }, null, 8, ["items"])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("div", _hoisted_9, [
                                                        _createElementVNode("div", _hoisted_10, [
                                                            _createElementVNode("div", null, [
                                                                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)(`auCapitals.capitalModal.1step.amount${vote.value}`) +
                                                                    " " +
                                                                    project.value.tokenQuote?.mnemonicEng), 1),
                                                                _createVNode(_component_AuInput, {
                                                                    id: "for-test-money-input",
                                                                    "model-value": moneyAmount.value,
                                                                    min: min.value,
                                                                    max: max.value,
                                                                    type: "Number",
                                                                    "onUpdate:modelValue": setMoneyAmount
                                                                }, null, 8, ["model-value", "min", "max"])
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_12, [
                                                            _createElementVNode("span", null, _toDisplayString(_unref(t)("auCapitals.capitalModal.1step.amountOfTokens")), 1),
                                                            _createElementVNode("span", null, [
                                                                _createVNode(_component_AuDecimalStatic, {
                                                                    value: tokenCount.value,
                                                                    decimal: 0,
                                                                    indent: 0,
                                                                    "show-addition": false
                                                                }, null, 8, ["value"])
                                                            ])
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_13, [
                                                    _createElementVNode("span", _hoisted_14, [
                                                        _createElementVNode("span", null, [
                                                            _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.1step.min")) + " ", 1),
                                                            _createVNode(_component_AuDecimalStatic, {
                                                                value: min.value,
                                                                decimal: 0,
                                                                addition: project.value.tokenQuote?.mnemonicEng
                                                            }, null, 8, ["value", "addition"])
                                                        ]),
                                                        _createElementVNode("span", null, [
                                                            _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.1step.max")) + " ", 1),
                                                            _createVNode(_component_AuDecimalStatic, {
                                                                value: max.value,
                                                                decimal: 0,
                                                                addition: project.value.tokenQuote?.mnemonicEng
                                                            }, null, 8, ["value", "addition"])
                                                        ])
                                                    ]),
                                                    _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)("auCapitals.capitalModal.1step.instantly")), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_16, [
                                                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)("auCapitals.capitalModal.1step.fromBalance")), 1),
                                                    _createElementVNode("span", null, [
                                                        _createVNode(_component_AuDecimalStatic, {
                                                            value: owner.value.amountFree,
                                                            decimal: owner.value.auToken.decimals,
                                                            indent: owner.value.auToken.indent,
                                                            "show-addition": false
                                                        }, null, 8, ["value", "decimal", "indent"])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_18, [
                                                    _createVNode(_component_AuButton, {
                                                        bordered: "",
                                                        width: "82px",
                                                        height: "34px",
                                                        center: "",
                                                        "border-radius": 12,
                                                        onClick: _cache[1] || (_cache[1] = ($event) => (getAmount(25)))
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                                _createElementVNode("span", { class: "percent" }, " 25% ", -1)
                                                            ]))]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_AuButton, {
                                                        bordered: "",
                                                        width: "82px",
                                                        height: "34px",
                                                        center: "",
                                                        "border-radius": 12,
                                                        onClick: _cache[2] || (_cache[2] = ($event) => (getAmount(50)))
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                                _createElementVNode("span", { class: "percent" }, " 50% ", -1)
                                                            ]))]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_AuButton, {
                                                        bordered: "",
                                                        width: "82px",
                                                        height: "34px",
                                                        center: "",
                                                        "border-radius": 12,
                                                        onClick: _cache[3] || (_cache[3] = ($event) => (getAmount(75)))
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                                _createElementVNode("span", { class: "percent" }, " 75% ", -1)
                                                            ]))]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_AuButton, {
                                                        bordered: "",
                                                        width: "82px",
                                                        height: "34px",
                                                        center: "",
                                                        "border-radius": 12,
                                                        onClick: _cache[4] || (_cache[4] = ($event) => (getAmount(100)))
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                                _createElementVNode("span", { class: "percent" }, " 100% ", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ])
                                            ], 64))
                                            : (step.value == 2)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)(`auCapitals.capitalModal.2step.title${vote.value}`)), 1),
                                                    _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)(`auCapitals.capitalModal.2step.subtitle${vote.value}`)), 1),
                                                    (projectTerms.value == 'autentic')
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            class: "terms",
                                                            style: _normalizeStyle(cssVars.value)
                                                        }, [
                                                            (isVoting.value)
                                                                ? (_openBlock(), _createBlock(TermsVote, { key: 0 }))
                                                                : (_openBlock(), _createBlock(Terms, { key: 1 }))
                                                        ], 4))
                                                        : (projectTerms.value == 'equal')
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 1,
                                                                class: "terms",
                                                                style: _normalizeStyle(cssVars.value)
                                                            }, [
                                                                _createVNode(TermsEqual)
                                                            ], 4))
                                                            : (_openBlock(), _createElementBlock("div", {
                                                                key: 2,
                                                                class: "terms",
                                                                style: _normalizeStyle(cssVars.value)
                                                            }, null, 4)),
                                                    _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)("auCapitals.capitalModal.2step.terms")), 1),
                                                    _createElementVNode("div", _hoisted_22, [
                                                        _createElementVNode("div", _hoisted_23, [
                                                            _createElementVNode("div", null, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    id: "for-test-terms-checkbox",
                                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((termsAgree).value = $event)),
                                                                    type: "checkbox",
                                                                    class: "checkbox"
                                                                }, null, 512), [
                                                                    [_vModelCheckbox, termsAgree.value]
                                                                ])
                                                            ]),
                                                            _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(t)("auCapitals.capitalModal.2step.termsAgree")), 1)
                                                        ]),
                                                        (!isVoting.value)
                                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(checkboxesData.value, (config, index) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                    key: index,
                                                                    class: "d-flex gap-2"
                                                                }, [
                                                                    _createElementVNode("div", null, [
                                                                        _withDirectives(_createElementVNode("input", {
                                                                            id: 'memorandumCheckbox' + index,
                                                                            "onUpdate:modelValue": ($event) => ((config.checked) = $event),
                                                                            type: "checkbox",
                                                                            class: "checkbox"
                                                                        }, null, 8, _hoisted_25), [
                                                                            [_vModelCheckbox, config.checked]
                                                                        ])
                                                                    ]),
                                                                    _createElementVNode("label", {
                                                                        class: "checkbox-label",
                                                                        for: 'memorandumCheckbox' + index
                                                                    }, [
                                                                        _createTextVNode(_toDisplayString(config.text) + " ", 1),
                                                                        _createElementVNode("label", {
                                                                            class: "link",
                                                                            disabled: config.loading,
                                                                            onClick: _withModifiers(($event) => (tryDownloadMemorandum(index)), ["prevent"])
                                                                        }, _toDisplayString(config.linkText), 9, _hoisted_27)
                                                                    ], 8, _hoisted_26)
                                                                ]));
                                                            }), 128))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ], 64))
                                                : (step.value == 3)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                        _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)("auCapitals.capitalModal.3step.title")), 1),
                                                        _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)(`auCapitals.capitalModal.3step.subtitle${vote.value}`)), 1),
                                                        _createElementVNode("div", _hoisted_30, [
                                                            _createVNode(AuList, { items: infoStep3.value }, null, 8, ["items"])
                                                        ])
                                                    ], 64))
                                                    : (step.value == 4)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                            _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)("auCapitals.capitalModal.4step.title")), 1),
                                                            _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)("auCapitals.capitalModal.4step.subtitle")), 1),
                                                            _createElementVNode("div", _hoisted_33, [
                                                                _createVNode(ProgressBar, {
                                                                    procent: procent.value,
                                                                    green: ""
                                                                }, null, 8, ["procent"]),
                                                                _createElementVNode("span", null, _toDisplayString(procent.value) + "%", 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_34, [
                                                                _createElementVNode("div", {
                                                                    checked: transactionsChecks.value.terms,
                                                                    class: "progress-line"
                                                                }, [
                                                                    _cache[18] || (_cache[18] = _createElementVNode("img", { src: "/img/project-card/check.svg" }, null, -1)),
                                                                    _createElementVNode("p", null, [
                                                                        _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.4step.terms")), 1),
                                                                        _cache[16] || (_cache[16] = _createElementVNode("span", null, "...", -1)),
                                                                        _cache[17] || (_cache[17] = _createElementVNode("span", null, "OK", -1))
                                                                    ])
                                                                ], 8, _hoisted_35),
                                                                _createElementVNode("div", {
                                                                    checked: transactionsChecks.value.balance,
                                                                    class: "progress-line"
                                                                }, [
                                                                    _cache[21] || (_cache[21] = _createElementVNode("img", { src: "/img/project-card/check.svg" }, null, -1)),
                                                                    _createElementVNode("p", null, [
                                                                        _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.4step.balance")), 1),
                                                                        _cache[19] || (_cache[19] = _createElementVNode("span", null, "...", -1)),
                                                                        _cache[20] || (_cache[20] = _createElementVNode("span", null, "OK", -1))
                                                                    ])
                                                                ], 8, _hoisted_36),
                                                                _createElementVNode("div", {
                                                                    checked: transactionsChecks.value.smartcontract,
                                                                    class: "progress-line"
                                                                }, [
                                                                    _cache[24] || (_cache[24] = _createElementVNode("img", { src: "/img/project-card/check.svg" }, null, -1)),
                                                                    _createElementVNode("p", null, [
                                                                        _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.4step.smartcontract")), 1),
                                                                        _cache[22] || (_cache[22] = _createElementVNode("span", null, "...", -1)),
                                                                        _cache[23] || (_cache[23] = _createElementVNode("span", null, "OK", -1))
                                                                    ])
                                                                ], 8, _hoisted_37),
                                                                _createElementVNode("div", {
                                                                    checked: transactionsChecks.value.received,
                                                                    class: "progress-line"
                                                                }, [
                                                                    _cache[27] || (_cache[27] = _createElementVNode("img", { src: "/img/project-card/check.svg" }, null, -1)),
                                                                    _createElementVNode("p", null, [
                                                                        _createTextVNode(_toDisplayString(isOpenSale.value ? project.value?.tokenBase?.mnemonicEng : selectedToken.value) + " " + _toDisplayString(_unref(t)("auCapitals.capitalModal.4step.received")), 1),
                                                                        _cache[25] || (_cache[25] = _createElementVNode("span", null, "...", -1)),
                                                                        _cache[26] || (_cache[26] = _createElementVNode("span", null, "OK", -1))
                                                                    ])
                                                                ], 8, _hoisted_38),
                                                                _createElementVNode("div", {
                                                                    checked: transactionsChecks.value.sent,
                                                                    class: "progress-line"
                                                                }, [
                                                                    _cache[30] || (_cache[30] = _createElementVNode("img", { src: "/img/project-card/check.svg" }, null, -1)),
                                                                    _createElementVNode("p", null, [
                                                                        _createTextVNode(_toDisplayString(_unref(t)("auCapitals.capitalModal.4step.sent")), 1),
                                                                        _cache[28] || (_cache[28] = _createElementVNode("span", null, "...", -1)),
                                                                        _cache[29] || (_cache[29] = _createElementVNode("span", null, "OK", -1))
                                                                    ])
                                                                ], 8, _hoisted_39),
                                                                (errorText.value)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(errorText.value), 1))
                                                                    : _createCommentVNode("", true)
                                                            ])
                                                        ], 64))
                                                        : (step.value == 5)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                                _createElementVNode("div", _hoisted_41, [
                                                                    _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)("auCapitals.capitalModal.5step.title")), 1),
                                                                    (isStakingPool.value)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_unref(t)("auCapitals.capitalModal.5step.subtitleStakingPool")), 1))
                                                                        : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                                            _createTextVNode(_toDisplayString(subtitle.value) + " ", 1),
                                                                            _createElementVNode("div", null, _toDisplayString(clampedName.value) + ".", 1)
                                                                        ]))
                                                                ]),
                                                                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "image d-flex justify-content-center" }, [
                                                                    _createElementVNode("img", { src: "/img/project-card/trophy.svg" })
                                                                ], -1)),
                                                                _createElementVNode("div", _hoisted_45, [
                                                                    (!isStakingPool.value)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                                                                            _createVNode(_component_AuDecimalStatic, {
                                                                                class: "lh-style",
                                                                                value: tokenCount.value,
                                                                                "show-addition": false
                                                                            }, null, 8, ["value"]),
                                                                            _createTextVNode(" " + _toDisplayString(clampedName.value) + " " + _toDisplayString(_unref(t)("auCapitals.capitalModal.5step.credited")), 1)
                                                                        ]))
                                                                        : _createCommentVNode("", true),
                                                                    _createElementVNode("a", {
                                                                        class: "link",
                                                                        target: "_blank",
                                                                        href: link.value
                                                                    }, _toDisplayString(_unref(t)("auCapitals.capitalModal.5step.check")), 9, _hoisted_47)
                                                                ])
                                                            ], 64))
                                                            : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["visible", "title", "height"]));
        };
    }
});
